export const NON_ANE_EVENT_TITLES = [
    // East Asia (China)
    "Xia Dynasty (China)",
    "Shang Dynasty (China)",
    "Zhou Dynasty (China)",
    "Qin Dynasty (China)",
    "Han Dynasty (China)",
    "First Chinese Writing (Oracle Bones)",
    "Confucius Born",
    "Lao Tzu and Taoism",
    "Great Wall of China Construction Begins",
    "Terracotta Army Created",
    "Paper Invented in China",
    "Han Dynasty Begins (China)",
    "Ban Zhao Writes 'Lessons for Women'",

    // South Asia (India)
    "Indus Valley Civilization",
    "Vedic Period (India)",
    "Maurya Empire (India)",
    "Buddha (Siddhartha Gautama) Born",
    "Ashoka Converts to Buddhism",

    // Americas
    "Olmec Civilization",
    "Maya Civilization (Preclassic)",
    "Chavín Culture (Peru)",

    // Europe / Mediterranean (Greece/Rome/etc)
    "Minoan Civilization (Crete)",
    "Mycenaean Greece",
    "Greek Dark Ages",
    "Archaic Greece",
    "Classical Greece",
    "Etruscan Civilization",
    "Roman Kingdom",
    "First Olympic Games",
    "Founding of Rome (Traditional)",
    "Trojan War (Traditional Date)",
    "Construction of Stonehenge Phase III",
    "Parthenon Completed",
    "Peloponnesian War Begins",
    "Julius Caesar in Gaul",
    "Roman Invasion of Britain",
    "Boudicca's Revolt",
    // Note: Battle of Marathon/Thermopylae are kept as context by default or filtered?
    // User requested specifically the ones starting with "Xia Dynasty" in that list section.
    // Based on the file structure, these were in the "broader world" section.
    "Battle of Marathon",
    "Battle of Thermopylae",

    // Africa (outside Egypt/ANE core)
    "Nubian Kingdoms (Kush)",
    "Axumite Empire",
    "Carthaginian Empire",
    "Founding of Carthage",
    "Destruction of Carthage",
    "Punic Wars Begin",
    "Cleopatra Rules Egypt", // Borderline, but in the generated list

    // Central Asia
    "Scythian Nomads",
    "Parthian Empire",
    "Silk Road Trade Begins",
    "Zoroaster's Teachings Spread",
];
